export default __webpack_public_path__ + "static/char-thumb-49-d90d04993c713a09896be1e815424465.png";